import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Box, CssBaseline, Toolbar } from '@mui/material';
import Header from './components/Header';
import Footer from './components/Footer';
import Homepage from './pages/Homepage';
import Graduacao from './pages/Cursos/Graduacao';
import PosGraduacao from './pages/Cursos/PosGraduacao';
import Extensao from './pages/Cursos/Extensao';
import CursoGraduacao from './pages/Cursos/curso/CursoGraduacao';
import CursoPos from './pages/Cursos/curso/CursoPos';
import CursoExtensao from './pages/Cursos/curso/CursoExtensao';
import Curso from './pages/Cursos/Curso';
import SobreCPA from './pages/CPA/SobreCPA';
import CardsPage from './components/CardsPage';
import Mantenedora from './pages/Institucional/Mantenedora';
import EstruturaFisica from './pages/Institucional/Estrutura-fisica';
import Sobre from './pages/Institucional/Sobre';
import NoticiaDetalhes from './components/NoticiaDetalhes';
import SecretariaAcademica from './pages/Secretaria/Secretaria-Academica';
import ServicosAoAluno from './pages/Secretaria/Servicos-Aluno';
import Biblioteca from './pages/Secretaria/Biblioteca';
import Monitoria from './pages/Secretaria/Monitoria';
import NucleoApoio from './pages/Secretaria/NucleoApoio';
import Contato from './pages/Fale Conosco/Contato';
import FAQ from './pages/Fale Conosco/FAQ';
import Ouvidoria from './pages/Fale Conosco/Ouvidoria';
import PesquisaInovacao from './pages/Pesquisa-Inovacao';
import PesquisaSolucoesEmpresas from './pages/Pesquisa-SolucoesEmpresas';
import PesquisaConsultoriaDetalhe from './pages/Pesquisa-ConsultoriaDetalhe';
import PesquisaObtec from './pages/Pesquisa-Obtec';
import PesquisaObtecPainel from './pages/Pesquisa-Obtec-Painel';
import VitrineTecnologica from './pages/Pesquisa-VitrineTecnologica';
import ICT from './pages/ICT-Senac';
import Vestibular from './pages/Cursos/Vestibular';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import PoliticaCookies from './pages/PoliticaCookies';
import LGPD from './pages/LGPD';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';
import RouteLoading from './components/RouteLoading';
import Revista from './pages/Revista';
import ProjetoVerticaliza from './pages/Projeto-Verticaliza';
import PromoPopup from './components/PromoPopup';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/admin/ProtectedRoute';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminLogin from './pages/admin/AdminLogin';
import AdminSetPassword from './pages/admin/AdminSetPassword';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminHomepageBannersPage from './pages/admin/AdminHomepageBannersPage';
import AdminHomepageEditaisPage from './pages/admin/AdminHomepageEditaisPage';
import AdminPromoPopupPage from './pages/admin/AdminPromoPopupPage';
import AdminSecadDocumentsPage from './pages/admin/AdminSecadDocumentsPage';
import AdminMonitoringDocumentsPage from './pages/admin/AdminMonitoringDocumentsPage';
import AdminCpaDocumentsPage from './pages/admin/AdminCpaDocumentsPage';
import AdminCoursesPage from './pages/admin/AdminCoursesPage';
import AdminStudentServicesPage from './pages/admin/AdminStudentServicesPage';
import AdminLibraryResourcesPage from './pages/admin/AdminLibraryResourcesPage';
import { adminPath, adminLoginPath, adminPasswordSetupPath } from './config/adminPath';

const MainContent: React.FC = () => {
  const location = useLocation();

  const isHomepage = location.pathname === '/' || location.pathname === '/home';
  const isAdminRoute = location.pathname.startsWith(adminPath);

  return (
    <>
      <CssBaseline />
      {!isAdminRoute && <Header />}
      {!isAdminRoute && <Toolbar id="back-to-top-anchor" />}
      <Box
        component="main"
        sx={
          isAdminRoute
            ? { minHeight: '100vh', bgcolor: '#f3f5f8' }
            : {
                minHeight: '100vh',
                ...(isHomepage
                  ? { backgroundColor: '#fff', px: 0 }
                  : { backgroundColor: '#f4f4f4', px: { xs: 2, md: 4 }, pb: 8 }),
              }
        }
      >
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/graduacao" element={<Graduacao />} />
          <Route path="/pos-graduacao" element={<PosGraduacao />} />
          <Route path="/extensao" element={<Extensao />} />
          <Route path="/curso/:id" element={<Curso />} />
          <Route path="/curso-graduacao/:id" element={<CursoGraduacao />} />
          <Route path="/curso-pos/:id" element={<CursoPos />} />
          <Route path="/curso-extensao/:id" element={<CursoExtensao />} />
          <Route path="/vestibular" element={<Vestibular />} />
          <Route path="/mantenedora" element={<Mantenedora />} />
          <Route path="/estrutura" element={<EstruturaFisica />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/secretaria/secad" element={<SecretariaAcademica />} />
          <Route path="/secretaria/servicos-aluno" element={<ServicosAoAluno />} />
          <Route path="/biblioteca/ambiente" element={<Biblioteca />} />
          <Route path="/secretaria/monitoria" element={<Monitoria />} />
          <Route path="/nucleo-apoio" element={<NucleoApoio />} />
          <Route path="/cpa/sobre" element={<SobreCPA />} />
          <Route path="/fies/*" element={<Navigate to="/" replace />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/ouvidoria" element={<Ouvidoria />} />
          <Route path="/pesquisa-inovacao" element={<PesquisaInovacao />} />
          <Route path="/pesquisa-inovacao/pdi" element={<Navigate to="/pesquisa-inovacao" replace />} />
          <Route
            path="/pesquisa-inovacao/solucoes-inovadoras-para-empresas"
            element={<PesquisaSolucoesEmpresas />}
          />
          <Route
            path="/pesquisa-inovacao/solucoes-inovadoras-para-empresas/:consultoriaId"
            element={<PesquisaConsultoriaDetalhe />}
          />
          <Route path="/pesquisa-inovacao/obtec" element={<PesquisaObtec />} />
          <Route path="/pesquisa-inovacao/obtec/painel-inteligencia" element={<PesquisaObtecPainel />} />
          <Route path="/pesquisa-inovacao/vitrine-tecnologica" element={<VitrineTecnologica />} />
          <Route path="/ict-senac" element={<ICT />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/noticia/:id" element={<NoticiaDetalhes />} />
          <Route path="/cards" element={<CardsPage />} />
          <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/politica-cookies" element={<PoliticaCookies />} />
          <Route path="/lgpd" element={<LGPD />} />
          <Route path="/revista" element={<Revista />} />
          <Route path="/projeto-verticaliza" element={<ProjetoVerticaliza />} />
          <Route path={adminLoginPath} element={<AdminLogin />} />
          <Route path={adminPasswordSetupPath} element={<AdminSetPassword />} />
          <Route element={<ProtectedRoute />}>
            <Route path={adminPath} element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="users" element={<AdminUsersPage />} />
              <Route path="homepage/banners" element={<AdminHomepageBannersPage />} />
              <Route path="homepage/editais" element={<AdminHomepageEditaisPage />} />
              <Route path="homepage/popup" element={<AdminPromoPopupPage />} />
              <Route path="secretaria/secad" element={<AdminSecadDocumentsPage />} />
              <Route path="secretaria/monitoria" element={<AdminMonitoringDocumentsPage />} />
              <Route path="cpa/documentos" element={<AdminCpaDocumentsPage />} />
              <Route path="secretaria/servicos-aluno" element={<AdminStudentServicesPage />} />
              <Route path="biblioteca/recursos" element={<AdminLibraryResourcesPage />} />
              <Route path="cursos" element={<AdminCoursesPage />} />
            </Route>
          </Route>
        </Routes>
      </Box>
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <CookieConsent />}
    </>
  );
};

const AppShell: React.FC = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith(adminPath);

  return (
    <>
      <ScrollToTop />
      <RouteLoading />
      {!isAdminRoute && <PromoPopup />}
      <MainContent />
    </>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AuthBoundary />
    </Router>
  );
};

const AuthBoundary: React.FC = () => {
  const location = useLocation();
  if (!location.pathname.startsWith(adminPath)) {
    return <AppShell />;
  }

  return (
    <AuthProvider>
      <AppShell />
    </AuthProvider>
  );
};

export default App;
